import "core-js/modules/es.object.to-string";
import Vue from 'vue';
/* eslint-disable */

var preventScroll = function preventScroll(el) {
  import('@tencent/vft-common/tenvideo').then(function (_ref) {
    var tenvideo = _ref.default;

    if (tenvideo.isTenvideo()) {
      tenvideo.tenvideoReady(function () {
        var startX;
        var startY;
        var hasIntercepted = false; // @ts-ignore

        $(el).off('touchstart').on('touchstart', function (e) {
          try {
            TenvideoJSBridge.invoke('requestSlideIntercept', {
              request: true
            });
          } catch (err) {}

          startX = e.touches[0].pageX;
          startY = e.touches[0].pageY;
          hasIntercepted = false;
        }).off('touchmove').on('touchmove', function (e) {
          var touch;
          var slope;

          if (hasIntercepted) {
            return;
          }

          touch = e.touches[0];
          slope = Math.abs((touch.pageY - startY) / (touch.pageX - startX));

          if (slope < 1) {
            try {
              TenvideoJSBridge.invoke('requestSlideIntercept', {
                request: true
              });
              hasIntercepted = true;
            } catch (err) {}
          } else {
            try {
              TenvideoJSBridge.invoke('requestSlideIntercept', {
                request: false
              });
              hasIntercepted = true;
            } catch (err) {}
          }
        }).off('touchend').on('touchend', function () {
          try {
            TenvideoJSBridge.invoke('requestSlideIntercept', {
              request: false
            });
            hasIntercepted = false;
          } catch (err) {}
        });
      });
    }
  });
};

Vue.directive('preventScroll', {
  bind: function bind(el, binding) {
    if (!binding.hasOwnProperty('value') || binding.value) {
      preventScroll(el);
    }
  },
  update: function update(el, binding) {
    // value更新
    if (!binding.oldValue && binding.value) {
      preventScroll(el);
    }
  },
  unbind: function unbind(el) {
    $(el).off('touchstart').off('touchmove').off('touchend');
  }
});